import { axiosOtherTrackerInstance } from "../../configs/AxiosInstance";

export const fetchUserTargetPlanSteps = async (get, eventTypeId, clientId) => {
  try {
    const response = await get(
      `/fetch-user-target-plan-steps?event_type_id=${eventTypeId}&client_id=${clientId}`,
      {
        instance: axiosOtherTrackerInstance,
      }
    );

    if (response && response.target_plan_steps) {
      return {
        success: true,
        data: {
          created: response.target_plan_steps.created || [],
          assigned: response.target_plan_steps.assigned || [],
          both: response.target_plan_steps.both || [],
        },
      };
    }

    return {
      success: false,
      message: "Target plan steps data not found",
    };
  } catch (error) {
    console.error("Error fetching user target plan steps:", error);
    return {
      success: false,
      message: "Error fetching user target plan steps",
    };
  }
};
